import { render } from "./DashboardLeave.vue?vue&type=template&id=5ee5f2d0"
import script from "./DashboardLeave.vue?vue&type=script&lang=js"
export * from "./DashboardLeave.vue?vue&type=script&lang=js"

import "./DashboardLeave.vue?vue&type=style&index=0&id=5ee5f2d0&lang=css"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__